module.exports = __webpack_public_path__ + "img/pain_campagne_half.141fe512.jpg";